import React from 'react';
import styled from '@emotion/styled';
import Input from './Input';

const Currency = styled('span')`
	flex: 0 0 auto;
	padding: 10px 0;

	${props => props.theme.currency || ''}
`;

export default function StyledInputCurrency(props) {
	return (
		<Input type="number" {...props}>
			<Currency>&nbsp;Kč</Currency>
		</Input>
	);
}
